/** @desc 闪送 */
export const ENTREGA = {
  ORDER_SHARE_URL: '/entrega/ordershare'
}
